import * as React from 'react';

import { Box, Flex, List, ListItem, ListItemProps, Text } from '@opendoor/bricks/core';
import imgixUrl from '@opendoor/bricks/helpers/imgixUrl';

import { BulletListElement } from 'src/lib/flow/FlowQuestion';

type BulletListInputProps = {
  props: BulletListElement['props'];
};

const BulletList: React.FC<BulletListInputProps> = ({ props }) => {
  const { faqs } = props;

  return (
    <Box>
      {faqs?.map((faq, index) => (
        <Flex
          flexDirection="column"
          justifyContent="center"
          textAlign="left"
          minWidth="325px"
          key={index}
        >
          <Text fontSize={['s2', 's3']} mb={2} fontWeight="semibold">
            {faq.title}
          </Text>
          <Text fontSize={['s0', 's1']} mb={4} color="neutrals90">
            {faq.subtitle}
          </Text>
          <List variant="checklist" ml={-2}>
            {faq.children.map((step, i) => (
              <ListItemCustom key={i}>{step}</ListItemCustom>
            ))}
          </List>
        </Flex>
      ))}
    </Box>
  );
};

function ListItemCustom({ children }: ListItemProps) {
  return (
    <ListItem listStyleImage={`url(${imgixUrl('ff18b88253db4bcaa61eab97ffa5793b.svg')})`}>
      <Box
        // Box and positioning to get the icon to align with the text
        left="10px"
        top="-3px"
        position="relative"
      >
        <Text color="neutrals90" fontSize="s1" mb={2}>
          {children}
        </Text>
      </Box>
    </ListItem>
  );
}
export default BulletList;
